import React, { useEffect, useCallback, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import SocialIconComponent from "../../components/SocialIconComponent";
import MenuLinks from "../../components/MenuLinks";
import MenuDrawer from "../../components/Drawer/MenuDrawer";
import { SidebarContext } from "../../Context/DrawerContext";
import { NavHashLink } from "react-router-hash-link";
import { scrollWithOffset } from "../../utils/helpers";
import { zivaLogoWhiteBg_Image, zivaLogo_Image } from "../../constants/imageConstants";
import { useContactModal } from "../../Context/ContactModalContext";

function Header() {
  const { mobileDrawer, toggleDrawer } = useContext(SidebarContext);
  const [isVisible, setIsVisible] = useState(true);
  const [height, setHeight] = useState(0);

  // Get showContactPopUp from context — cancels 60s timer automatically
  const { showContactPopUp } = useContactModal();

  const BookAppointmentButtonComponent = () => {
    return (
      <button
        onClick={showContactPopUp}
        className="bg-main text-white p-2 rounded-md"
        type="button"
      >
        Book Appointment Now
      </button>
    );
  };

  const listenToScroll = () => {
    let heightToHideFrom = 150;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    setHeight(winScroll);

    if (winScroll > heightToHideFrom) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  const listenScroll = useCallback(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, [listenToScroll]);

  useEffect(() => {
    listenScroll();
  }, []);

  const visibleTextColor = isVisible ? "text-white" : "text-black";
  const visibleBgColor = isVisible ? "bg-white" : "bg-black";

  return (
    <>
      {isVisible ? (
        <div className="flex flex-row justify-between items-center absolute z-20 w-full px-6 py-2 bg-transparent gap-20 lg:flex hidden">
          <div className="flex-none">
            <div className="flex flex-row items-center gap-2">
              <SocialIconComponent isVisible={isVisible} />
            </div>
          </div>
          <div className="grow">
            <div className="items-center flex flex-col gap-2">
              <NavHashLink to="/#home" scroll={(el) => scrollWithOffset(el, 120)}>
                <img
                  src={zivaLogoWhiteBg_Image}
                  className="w-full h-20 object-contain"
                  alt="logo"
                />
              </NavHashLink>
              <span className="w-full h-1 bg-white"></span>
              <MenuLinks isVisible={visibleTextColor} />
            </div>
          </div>
          <div className="flex-none">
            <BookAppointmentButtonComponent />
          </div>
        </div>
      ) : (
        <div className="flex flex-row justify-between items-center px-6 py-2 bg-white gap-20 sticky animate-fade-in-down shadow top-0 z-20 w-full lg:flex hidden">
          <div className="flex flex-col">
            <NavHashLink to="/#home" scroll={(el) => scrollWithOffset(el, 120)}>
              <img src={zivaLogo_Image} className="h-14" alt="logo" />
            </NavHashLink>
            <span className="w-full h-1 bg-black mt-1"></span>
          </div>
          <div className="">
            <div className="items-center flex flex-col gap-2">
              <MenuLinks isVisible={visibleTextColor} />
            </div>
          </div>
          <div className="flex flex-row items-center gap-5">
            <div className="flex flex-row items-center gap-2">
              <SocialIconComponent isVisible={isVisible} />
            </div>
            <BookAppointmentButtonComponent />
          </div>
        </div>
      )}
      <>
        <div className="flex flex-col h-full justify-between align-middle bg-white rounded cursor-pointer overflow-y-scroll flex-grow w-full">
          <MenuDrawer drawerOpen={mobileDrawer} toggleDrawer={toggleDrawer} />
        </div>
        <div
          className={`flex flex-row justify-between items-center fixed z-20 w-full p-2 ${
            isVisible ? "bg-transparent" : "bg-white"
          } ${!isVisible && "shadow"} lg:hidden`}
        >
          <div className="flex items-center">
            <Link
              key={"menu"}
              onClick={toggleDrawer}
              to={"/"}
              className="w-10 h-10 mr-2 rounded-md border transitions flex justify-center items-center"
            >
              <BiMenu size={30} className={visibleTextColor} />
            </Link>
            <div className="flex flex-col w-[100px]">
              <NavHashLink
                to="/#home"
                className="w-80"
                scroll={(el) => scrollWithOffset(el, 120)}
              >
                <img
                  src={isVisible ? zivaLogoWhiteBg_Image : zivaLogo_Image}
                  className="h-10 object-cover"
                  alt="logo"
                />
              </NavHashLink>
              <span className={`w-32 h-1 mt-1 ${visibleBgColor}`}></span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <BookAppointmentButtonComponent />
          </div>
        </div>
      </>
      {/* No Modal here — handled solely by ContactModalContext */}
    </>
  );
}

export default Header;